
import vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },

  props: {
    title: {
      type: String,
    },

    objName: {
      type: String,
    },

    customDateStart: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    dateShow: false,
    picker: new Date().toISOString().substr(0, 10),
    dates: [],
  }),

  computed: {
    dateRangeText() {
      return this.dates.map((el) => el.replaceAll("-", ".")).join(" - ");
    },

    allowedEvents(val) {
      return val >= new Date().toISOString().substr(0, 10);
    },

    arrayEvents() {
      return ["2021-06-26", "2021-06-29"];
    },
  },

  watch: {
    dates() {
      this.$emit("add", this.dates);
    },
  },

  mounted() {
    window.addEventListener("load", () => {
      this.updateEventsDate();
    });
  },

  updated() {
    this.updateEventsDate();
  },

  methods: {
    openDates() {
      this.dateShow = true;
    },

    resetPicker() {
      this.dates = [];
      this.dateShow = false;
    },

    allowedDates(val) {
      if (this.customDateStart == "none") return true;
      if (this.customDateStart == "disable-future") {
        return val <= new Date().toISOString().substring(0, 10);
      }
      if (this.customDateStart.length) {
        return (
          val >=
            new Date(this.customDateStart).toISOString().substring(0, 10) &&
          val <= new Date().toISOString().substring(0, 10)
        );
      } else {
        return (
          val >= new Date().toISOString().substring(0, 10) &&
          this.arrayEvents.indexOf(val) == -1
        );
      }
    },

    onClickOutside() {
      this.dateShow = false;
    },

    updateEventsDate() {
      const arr = document.querySelectorAll(".v-date-picker-table__events");
      arr.forEach((el) => {
        el.parentNode.classList.add("blocked");
      });
    },
  },
};
